(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-divider-line",
        style: {
          'margin-left': _vm.px2remHorizontal,
          'margin-right': _vm.px2remHorizontal,
          'margin-top': _vm.px2remVertical,
          'margin-bottom': _vm.px2remVertical
        }
      });
    },
    name: 'nx-divider-line',
    components: {},
    props: {
      horizontalMargin: {
        type: Number,
        default: 60
      },
      verticalMargin: {
        type: Number,
        default: 60
      }
    },
    data: function data() {
      return {};
    },
    computed: {
      px2remHorizontal: function px2remHorizontal() {
        return this.horizontalMargin / 100 + 'rem';
      },
      px2remVertical: function px2remVertical() {
        return this.verticalMargin / 100 + 'rem';
      }
    },
    methods: {}
  };
  _exports.default = _default;
});